"use client"
import * as React from "react"

import Image from "next/image"
import Link from "next/link"

import DialogConfirm from "@/shared/components/DialogConfirm/DialogConfirm"
import FormInput from "@/shared/components/FormInput"
import { Heading1 } from "@/shared/components/Heading1/Heading1"
import { Paragraph } from "@/shared/components/Paragraph/Paragraph"
import { useThemeContext } from "@/shared/components/providers/theme-provider"
import { Button } from "@/shared/shadcn/ui/button-old"
import { Form } from "@/shared/shadcn/ui/form"

import { useLogin } from "../../hooks/useLogin"

export default function BaseLoginList() {
  const { theme, customTheme } = useThemeContext()
  const [mounted, setMounted] = React.useState(false)

  React.useEffect(() => {
    setMounted(true)
  }, [])

  const {
    isLoadingLogin,
    form,
    onSubmit,
    isOpen,
    closeModal,
  }: any = useLogin()

  if (!mounted) {
    return null
  }

  const isDark = theme === "dark" || customTheme === "dark" || customTheme === "night"

  return (
    <>
      <div className="w-full">
        <div className="xl:px-24 px-6 flex flex-col items-start justify-center h-full">
          <Link
            className="cursor-pointer mx-auto mb-10"
            href="/"
          >
            <Image
              alt="logo"
              className="h-12 w-full"
              height={48}
              priority
              src="/images/logo-dark.png"
              width={276}
            />
          </Link>

          <Heading1 className="text-primary font-semibold">Sign In</Heading1>
          <Paragraph className="text-text-secondary">
            Login and enjoy our best features!
          </Paragraph>

          <div className="max-w-full w-full">
            <Form {...form}>
              <form
                onSubmit={form.handleSubmit(() => onSubmit(form.getValues()))}
              >
                <FormInput
                  control={form.control}
                  label="Email"
                  name="emailOrUsername"
                  placeholder="Johndoe@gmail.com"
                  required
                  type="email"
                />
                <FormInput
                  control={form.control}
                  label="Password"
                  name="password"
                  placeholder="Enter your password"
                  required
                  type="password"
                />

                <div className="flex items-end justify-end">
                  <Link
                    className="font-semibold text-text-info-primary text-sm mt-3"
                    href="/auth/forgot-password"
                  >
                    Forgot Password
                  </Link>
                </div>
                <Button
                  className="max-w-full w-full mt-10 2xl:p-6 xl:-0 lg:p-0 md:p-0 p-0 2xl:text-lg xl:text-base lg:text-base md:text-base text-base bg-gradient-buttons-button-action-bg"
                  disabled={
                    form.watch("password").split("").length < 8 ||
                    isLoadingLogin
                  }
                  type="submit"
                >
                  {isLoadingLogin ? "Loading ..." : "Login"}
                </Button>
              </form>
            </Form>
          </div>
        </div>
      </div>
      {isOpen && (
        <DialogConfirm
          open={isOpen}
          secondaryButton="Cancel"
          setOpen={closeModal}
          subtitle="You'll be logged out from other device if you continue."
          primaryButton="Continue Login"
          // primaryButtonAction={() => onSubmitContinueLogin(form.getValues())}
          secondaryButtonAction={closeModal}
          title="You have an active session on another device."
          // isLoading={isLoadingContinueLogin}
        />
      )}
    </>
  )
}
